import React, { Component, MouseEvent } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { Fader } from "@formant/ui/component/common/Fader";
import { IconName } from "@formant/ui/component/common/Icon";

import * as styles from "./Collapsible.scss";
import { LineButton } from "./LineButton";

export interface ICollapsibleProps {
    top?: boolean;
    bottom?: boolean;
    left?: boolean;
    right?: boolean;
    className?: string;
    menuClassName?: string;
    minWidth?: number;
    relative?: boolean;
    icon: IconName;
    buttonText: string;
    buttonTooltip?: string;
    children?: React.ReactNode;
}

@observer
export class Collapsible extends Component<ICollapsibleProps> {
    @observable
    private open: boolean = false;

    public render() {
        const { open, onClose, onClick } = this;
        const {
            children,
            className,
            top,
            bottom,
            left,
            right,
            relative,
            menuClassName,
            icon,
            buttonText,
        } = this.props;

        return (
            <>
                {open && (
                    <div className={styles.background} onClick={onClose} />
                )}
                <div
                    className={classnames(
                        styles.collapsible,
                        styles.expanded,
                        relative && styles.relative,
                        className,
                    )}
                    onClick={onClick}
                >
                    {children}
                </div>
                <div
                    className={classnames(styles.collapsible, styles.collapsed)}
                >
                    <LineButton
                        icon={icon}
                        responsive={true}
                        toggled={open}
                        onClicked={this.onOpenToggle}
                    >
                        {buttonText}
                    </LineButton>
                    <Fader
                        visible={open}
                        className={classnames(
                            styles.menu,
                            menuClassName,
                            top && styles.top,
                            bottom && styles.bottom,
                            left && styles.left,
                            right && styles.right,
                        )}
                    >
                        {children}
                    </Fader>
                </div>
            </>
        );
    }

    private onOpenToggle = () => {
        this.open = !this.open;
    };

    private onClose = () => {
        this.open = false;
    };

    private onClick = (event: MouseEvent) => {
        event.stopPropagation();
    };
}
